<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <config-title-hang>
          <span slot="config_title_hang_ele2">搜索到的主机列表</span>
          <img slot="config_title_hang_ele5_img"
               src="~assets/img/config/shuaxin_bai.png"
               alt
               @click="shuaXinBtnHandle" />
          <span slot="config_title_hang_ele5"
                @click="shuaXinBtnHandle">刷新搜索</span>
        </config-title-hang>

        <config-hang v-for="value in serveautoSearchHostListData"
                     :key="value.gatewayId"
                     @click.native="addChangeHostBtnHandle(value)">
          <span slot="config_hang_ele2">{{ value.gatewayName }}（{{ value.intranetIp }}）</span>
          <!-- //代号20220220-6 -->
          <span slot="config_hang_ele3">点击绑定</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt />
        </config-hang>

        <!-- 没有搜索到任何主机时显示 -->
        <div v-if="serveautoSearchHostListDataLength === 0"
             class="tips_text_nei_rong_wraper">
          <div class="biao_ti_tips">很抱歉，未能搜索到任何主机，可能是以下原因：</div>
          <div class="nei_rong_tips">1,PC联网不正常</div>
          <div class="nei_rong_tips">2,主机联网不正常</div>
          <div class="nei_rong_tips">3,PC和主机不在同一个局域网</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from "components/common/config/config-title-hang";

import configHang from "components/common/config/config-hang";
export default {
  data () {
    return {
      serveautoSearchHostListData: [
        ////服务器请求到的主机列表
      ],
      serveautoSearchHostListDataLength: 1,
      extranetIp: ""  ///外网IP地址
    };
  },
  components: {
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    shuaXinBtnHandle () {
      ///刷新按钮被点击了  首先获取外网IP 成功之后 在获取与外网IP 一样的网关信息 //代号20221222-1
      this.$extranet_ip_request({
        method: "get",
        url: "",
      })
        .then(res => {
          console.log(res);
          this.extranetIp = res;
          this.$request({
            method: "post",
            url: "/gateway/findUnBindGatewayList",
            data: {
              token: this.$store.state.token,
              extranetIp: this.extranetIp
            }
          })
            .then(res => {
              if (res.data.code != 0) {
                this.$showTipsToast(3, res.data.message);
                ////说明信息填写错误,控制失败了，
                return;
              } else {
                ////、控制成功了
                this.serveautoSearchHostListData = res.data.data; ////拿到服务器返回的数据结果
                this.serveautoSearchHostListDataLength = this.serveautoSearchHostListData.length;
                console.log(this.serveautoSearchHostListDataLength);
                console.log(res.data.data);
                // this.$showTipsToast(1, "获取成功", true); ////提示框
              }
            })
            .catch(error => {
              console.log(error);
            });

        })
        .catch(error => {
          console.log(error);
        });
    },
    addChangeHostBtnHandle (value) {
      ///一个主机按钮被点击了
      this.$router.push({
        path: "addChangeHost",
        query: { type: "add", uniqueCode16: value.uniqueCode16 }
      });
    }
  },

  mounted () {
    console.log("mounted阶段");
  },
  created () {
    console.log("created阶段");
    this.shuaXinBtnHandle();
  }
};
</script>

<style>
.biao_ti_tips {
  font-size: 18px;
}
</style>
